/*
    © Copyright LinkHMS B.V. All rights reserved.
    * Proprietary and confidential.
    * Unauthorized copying of this file, via any medium is strictly prohibited.
*/
import { LocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule, TransferState } from '@angular/core';
import { CommonMissingTranslationHandler, I18nService } from '@core/services/i18n.service';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { TranslatesBrowserLoaderService } from './translates-browser-loader.service';

export function translateStaticLoader(
  http: HttpClient,
  transferState: TransferState,
  locationStrategy: LocationStrategy,
): TranslatesBrowserLoaderService {
  const baseHref = locationStrategy.getBaseHref();

  return new TranslatesBrowserLoaderService(
    transferState,
    http,
    `${baseHref}assets/i18n/`,
    '.json',
  );
}

@NgModule({
  imports: [
    TranslateModule.forRoot({
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CommonMissingTranslationHandler,
      },
      loader: {
        provide: TranslateLoader,
        useFactory: translateStaticLoader,
        deps: [HttpClient, TransferState, LocationStrategy],
      },
    }),
  ],
  providers: [I18nService],
})
export class TranslatesBrowserModule {}
